<template>
  <div class="big">
    <div class="page_title">剂型药库模板配置管理</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item
            index="1"
            style="font-size:16px"
          >医生模板查询</el-menu-item>
          <el-menu-item
            index="2"
            style="font-size:16px"
            :disabled="module_id_array[0]? !module_id_array.includes('983'): false"
          >省市医生模板配置</el-menu-item>
          <el-menu-item
            index="3"
            style="font-size:16px"
            :disabled="module_id_array[0]? !module_id_array.includes('988'): false"
          >特殊医生模板配置</el-menu-item>
          <el-menu-item
            index="4"
            style="font-size:16px"
            :disabled="module_id_array[0]? !module_id_array.includes('830'): false"
          >模板管理</el-menu-item>
        </el-menu>
        <div class="box">
          <div class="component">
            <keep-alive>
              <component :is="currentComponent" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import DoctorTem from './DoctorTem.vue';
import ProvinceTem from './ProvinceTem.vue';
import SpecialTem from './SpecialTem.vue';
import TemList from './TemList.vue';

export default {
  data() {
    return {
      activeIndex: '1',
      active: '1'
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.active) {
        case '1':
          return DoctorTem;
        case '2':
          return ProvinceTem;
        case '3':
          return SpecialTem;
        case '4':
          return TemList;
        default:
          return DoctorTem;
      }
    }
  },
  methods: {
    //绑定医生
    bindDoctor() {
      this.$router.push('addtemdoctor');
    },
    //
    delTemplate(tmp_id, doctor_count) {
      if (doctor_count > 0) {
        this.$alert(
          '该模板已有医生使用，不可删除。请先解除已绑定医生。',
          '提示',
          {
            confirmButtonText: '确定'
          }
        );
      } else {
        this.axios
          .post('platform/Drugtype/deldrugTypeTemplate', { tmp_id })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('删除成功');
              this.getList();
            }
          });
      }
    },
    handleSelect(key) {
      this.active = key;
    }
  }
};
</script>

<style lang="scss" scoped>
.searchbox {
  display: flex;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}

.container {
  padding: 10px 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 237px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  margin-top: 16px;
  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>